import React, { useState, useRef, useEffect } from 'react';
import { FiLogOut } from 'react-icons/fi';
import { NavLink } from "react-router-dom";
import logo from "./../../../assets/global_assets/dashboard_imgs/logo.png"; 
import { RiLockPasswordFill } from 'react-icons/ri';
import { useNavigate } from 'react-router-dom';
import giftBox from "./../../../assets/global_assets/nav_imgs/giftBox.png";
import "./navbar.css";
import NotificationBell from "./NotificationBell";
import { useDispatch, useSelector } from 'react-redux';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { getUserRole } from "./../../../services/global_redux/globale_actions/Role.action"
import arrowLeft from "./../../../assets/global_assets/dashboard_imgs/sidebarClose.png"
import arrowRight from "./../../../assets/global_assets/dashboard_imgs/sidebarOpen.png"
import { useLocation } from 'react-router-dom';
import {  uploadUserProfile, getUserProfile, deleteUserProfile } from "../../../services/global_redux/globale_actions/Login.action";
import { GoChevronDown } from "react-icons/go";
import { GoChevronUp } from "react-icons/go";
import { FaUser } from "react-icons/fa";

import { getCompanyDetails} from "./../../../services/global_redux/globale_actions/CompanyDetails.action"
import { getClients } from "./../../../services/global_redux/globale_actions/Client.action"

const PROFILE_ALLOWED_TYPES = ["image/jpeg", "image/jpg", "image/png"];
const PROFILE_ALLOWED_EXT = [".jpg", ".jpeg", ".png"];

function DefaultProfileAvatar({ size = 36, className = "" }) {
  return (
    <span
      className={`nav-default-avatar ${className}`}
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      <FaUser />
    </span>
  );
}

function ProfileImage({ src, size = 36, className = "", onClick, alt = "Profile" }) {
  if (src) {
    return (
      <img
        className={className || "nav-profile-avatar"}
        src={src}
        alt={alt}
        onClick={onClick}
        style={{
          width: size,
          height: size,
          borderRadius: "50%",
          objectFit: "cover",
          border: "1px solid #dbe7ff",
          background: "#f0f5ff",
          cursor: onClick ? "pointer" : undefined,
        }}
      />
    );
  }
  const avatar = <DefaultProfileAvatar size={size} className={className} />;
  if (!onClick) return avatar;
  return (
    <button
      type="button"
      className="nav-default-avatar-btn"
      onClick={onClick}
      aria-label={alt}
      style={{ width: size, height: size }}
    >
      {avatar}
    </button>
  );
}

function Navbar({ showSnackbar, sidebarOpen, setSidebarOpen,onSearch }) {
  const profileRef = useRef(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [openlogout, setOpenlogout] = useState(false);
    const [permissionsSections, setPermissionsSections] = useState(null);
    const [isProfileOpen, setIsProfileOpen] = useState(false);
    const [activeTab, setActiveTab] = useState(null);
    const [userProfileUrl, setUserProfileUrl] = useState(null);
    const [openRemoveProfile, setOpenRemoveProfile] = useState(false);
    const [sliderStyle, setSliderStyle] = useState({});
    const registerRef = useRef(null);  
    const use_company_code = JSON.parse(sessionStorage.getItem('user'));
    const currentUserBaseRole = use_company_code?.base_role;
    const companyName = use_company_code?.company_name;
    const [headerTitle, setHeaderTitle] = useState(companyName || "");
    const auditRef = useRef(null);
    const fileInputRef = useRef(null);
    const [currentCompany, setCurrentCompany] = useState(
      JSON.parse(sessionStorage.getItem('user'))?.company_code
    );
    const [companyServices, setCompanyServices] = useState([]);    
    const hasAuditAccess = companyServices.includes("Audit");
    const hasRegisterAccess = companyServices.includes("Registers");
  const getCompanyDetailbyid = async () => {
    try {
      const response = await dispatch(getCompanyDetails(currentCompany));
  
      if (response.success === true) {
        setCompanyServices(response.data.services);
      }
    } catch (err) {
      console.error("Failed to fetch company details:", err);
    }
  };
  useEffect(() => { 
    if (currentCompany) {
      getCompanyDetailbyid();
    }
  }, [currentCompany]);

  useEffect(() => {
    if (currentUserBaseRole !== "Client") {
      setHeaderTitle(companyName || "");
      return;
    }
    const loadOrgName = async () => {
      try {
        const response = await dispatch(getClients());
        const payload = response?.data;
        const rows = Array.isArray(payload)
          ? payload
          : Array.isArray(payload?.data)
            ? payload.data
            : [];
        let assignedIds = [];
        try {
          assignedIds = JSON.parse(use_company_code?.client_and_unit || "[]")
            .map((entry) => String(entry?.client_id || "").trim())
            .filter(Boolean);
        } catch {
          assignedIds = [];
        }
        const selectedId = sessionStorage.getItem("selectedClient");
        const match =
          (selectedId && selectedId !== "null"
            ? rows.find((c) => String(c.client_id) === String(selectedId))
            : null) ||
          rows.find((c) => assignedIds.includes(String(c.client_id))) ||
          rows[0];
        if (match?.client_id) {
          sessionStorage.setItem("selectedClient", String(match.client_id));
        }
        setHeaderTitle(match?.client_name || match?.organization_name || companyName || "");
      } catch (err) {
        console.error("Failed to fetch organization name:", err);
        setHeaderTitle(companyName || "");
      }
    };
    loadOrgName();
  }, [currentUserBaseRole, companyName, dispatch]);

    const location = useLocation();
    const currentPath = location.pathname

      let titleName = 'Dashboard';
 
    if (currentPath.startsWith('/input-matrix')) {
      titleName = 'Input Matrix';
    } else if (currentPath.startsWith('/configuration')) {
      titleName = 'Configuration';
    } else if (currentPath.startsWith('/settings')) {
      titleName = 'Settings';
    }
    const handleClickOpenlogout = () => {
        setOpenlogout(true);
    };
    const handleCloselogout = () => {
        setOpenlogout(false);
    };
    const modelToggleChangedata = (data) => {

      moveSlider(data);
      if(sessionStorage.getItem('activeTab') !== data){
        setActiveTab(data);
        sessionStorage.setItem("activeTab", data);
        window.location.href = '/dashboard';
      }
    };
    const modelToggleChange = (tabName) => {
      if (tabName === "Audit" && !hasAuditAccess ) {
        showSnackbar("You don't have access for Audit", "warning");
        return;
      }
    
      if (tabName === "Registers" && !hasRegisterAccess ) {
        showSnackbar("You don't have access for Registers", "warning");
        return;
      }
      modelToggleChangedata(tabName);
    };
    const moveSlider = (data) => {
      const activeRef = data === "Registers" ? registerRef : auditRef;
  
      if (activeRef?.current) {
        setSliderStyle({
          width: activeRef.current.offsetWidth + "px",
          transform: `translateX(${activeRef.current.offsetLeft}px)`,
        });
      }
    };
    useEffect(() => {
    
      // const timeout = setTimeout(moveSlider, 0);
    
      // if (activeTab) sessionStorage.setItem("activeTab", activeTab);
    
      // return () => clearTimeout(timeout);
    }, [activeTab]);
    
    useEffect(() => {
      const savedTab = sessionStorage.getItem('activeTab') || "Registers";
      setActiveTab(savedTab);
    }, []);
    
    


    const loggedInUser = JSON.parse(sessionStorage.getItem('user'))?.user_name;
    const loggedInrole = JSON.parse(sessionStorage.getItem('user'))?.role_name;

    const handleLogout = () => {
        localStorage.removeItem('token');
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('user');
        sessionStorage.removeItem('dashboardAlertShown');
        sessionStorage.removeItem('selectedClient');
        sessionStorage.removeItem('selectedAudit');
        navigate('/login');
        window.location.reload();
    };

    const getUserPermission = async () => {
        try {
            const response = await dispatch(getUserRole());
            setPermissionsSections(response.data);
        } catch (err) {
            console.error("Failed to fetch states:", err);
        }
    };
    useEffect(() => {
        getUserPermission();
    }, [dispatch]);
    
    useEffect(() => {
        const dropdownToggles = document.querySelectorAll('.dropdown-submenu .dropdown-toggle');

        dropdownToggles.forEach((element) => {
            element.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                this.nextElementSibling.classList.toggle('show');
            });
        });

        return () => {
            dropdownToggles.forEach((element) => {
                element.removeEventListener('click', () => { });
            });
        };
    }, []);
    useEffect(() => {
        const handleClickOutside = (event) => {
          if (profileRef.current && !profileRef.current.contains(event.target)) {
            setIsProfileOpen(false);
          }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
      }, []);
      
      const profileUser = async () => {
        try{
          const response = await dispatch(getUserProfile());
          const url = response?.success ? (response.data?.data || response.data?.profile) : null;
          if (url && typeof url === "string" && url !== "null" && !url.includes("undefined")) {
            setUserProfileUrl(`${url}?t=${Date.now()}`);
          } else {
            setUserProfileUrl(null);
          }
        } catch(err){
          console.error("error",err);
          setUserProfileUrl(null);
        }
        
      }
  useEffect(() => {
    profileUser();
  }, [dispatch]);
    // if (!permissionsSections || permissionsSections.length === 0) return null;

  const handleImageClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;

    const name = (file.name || "").toLowerCase();
    const extOk = PROFILE_ALLOWED_EXT.some((ext) => name.endsWith(ext));
    const typeOk = !file.type || PROFILE_ALLOWED_TYPES.includes(file.type.toLowerCase());
    if (!extOk || !typeOk) {
      showSnackbar?.("You can only upload image JPG or PNG", "error");
      return;
    }
    uploadUserImg(file);
  };

  const uploadUserImg = async (file) =>{
    try{
      const response = await dispatch(uploadUserProfile(file));
      if(response.success === true){
          setUserProfileUrl(`${response.data}?t=${Date.now()}`);
          showSnackbar?.("Profile photo updated", "success");
      } else {
          showSnackbar?.(response.message || "You can only upload image JPG or PNG", "error");
      }
    } catch(err){
      console.error("error",err)
      showSnackbar?.("You can only upload image JPG or PNG", "error");
    }
  }

  const profileImgSrc = userProfileUrl || null;

  const handleRemoveProfile = async () => {
    try {
      const response = await dispatch(deleteUserProfile());
      if (response.success === true) {
        setUserProfileUrl(null);
        setOpenRemoveProfile(false);
        showSnackbar?.("Profile photo removed", "success");
      } else {
        showSnackbar?.(response.message || "Failed to remove profile", "error");
      }
    } catch (err) {
      console.error("error", err);
      showSnackbar?.("Failed to remove profile", "error");
    }
  };
      
  const handleSearchChange = (e) => {
    onSearch(e.target.value);
  };
  

  const menuItems = [
    { title: "Dashboard", link: "/dashboard" },
    { title: "InputMatrix", link: "/input-matrix" },
    { title: "Generated Form", link: "/generated-form" },
    { title: "Reports", link: "/report" },
    { title: "Returns", link: "/returns" },
    { title: "Compliance Documents", link: "/compliance-documents" },
    {
      title: "Configuration",
      children: [
        { title: "User permission", link: "/configuration/user-role-management" },
        {
          title: "User & Role Management",
          children: [
            { title: "Create Role", link: "/configuration/user-role-management/role" },
            { title: "Assign Permissions", link: "/configuration/user-role-management/role-permission" },
            { title: "Create Users", link: "/configuration/user-role-management/users" },
            { title: "Assign Client", link: "/configuration/user-role-management/users-client" }
          ],
        },
        { title: "Org Details", link: "/configuration/org-details" },
        { title: "Holidays", link: "/configuration/holidays" },
        { title: "Branch Holidays", link: "/configuration/branch-holidays" },
        { title: "Form Configuration", link: "/configuration/form-configuraion" },
        { title: "Employee Branch Transfer", link: "/configuration/employee-branch-transfer" },
        { title: "Leave Configuration", link: "/configuration/leave-type-configuration" },
        {
          title: "Developer Setting",
          children: [
            { title: "Access Configuration", link: "/configuration/developer-settings/access-configuration" },
            { title: "States", link: "/configuration/developer-settings/configuration/states" },
          ],
        },
      ],
    }
  ];

  
  const formatValidPermissions = (permissions) => {
    const result = {};
    if (permissions && typeof permissions[0] === "string") {
      try {
        permissions = JSON.parse(permissions[0]);
      } catch (e) {
        console.error("Invalid permission JSON", e);
        return result;
      }
    }
    if (permissions) {
      permissions.forEach(({ section, module, sub_module }) => {
        if (!section || !module) return;
        const normalizedSection = section === "Generated Forms" ? "Generated Form" : section;
        const normalizedModule = module === "Generated Forms" ? "Generated Form" : module;
        if (Array.isArray(sub_module)) {
          const validSubModules = sub_module.filter((sub) => sub && sub.name);
          if (!result[normalizedSection]) result[normalizedSection] = {};
          result[normalizedSection][normalizedModule] =
            validSubModules.length > 0
              ? validSubModules.map((sub) => sub.name)
              : sub_module.map((sub) => sub.name);
        } else {
          if (!result[normalizedSection]) result[normalizedSection] = {};
          result[normalizedSection][normalizedModule] = [];
        }
      });
    }
    return result;
  };

  const permissionMap = permissionsSections
    ? formatValidPermissions(permissionsSections.permissions)
    : null;

    const filterMenuByPermission = (items, permissions) => {
      if (!permissions || typeof permissions !== "object") {
        permissions = {};
      }
      return items
        .map((item) => {
          if (["Dashboard","Reports","Returns","Form Configuration","States","Compliance Documents"].includes(item.title)) {
            return item;
          }
    
          if (item.children) {
              const permForItem = permissions[item.title];
      
            if (Array.isArray(permForItem)) {
              if (permForItem.length === 0) {
                return { ...item, children: [] };
              }
              const allowedChildren = item.children.filter((child) =>
                permForItem.includes(child.title)
              );
              if (allowedChildren.length > 0) {
                return { ...item, children: allowedChildren };
              }
              return null;
            }
    
            if (typeof permForItem === "object" && permForItem !== null) {
              const filteredChildren = filterMenuByPermission(
                item.children,
                permForItem
              );
              if (filteredChildren.length > 0) {
                return { ...item, children: filteredChildren };
              }
    
              if (permissions.hasOwnProperty(item.title)) {
                return { ...item, children: [] };
              }
              return null;
            }
    
            return null;
          }
    
          const perm =
            permissions[item.title] ||
            (item.title === "Generated Form" ? permissions["Generated Forms"] : undefined);
    
          if (Array.isArray(perm)) {
            return item;
          }
    
          if (
            item.link &&
            item.title === 'Employee Branch Transfer' &&
            Array.isArray(permissions['Form Configuration'])
          ) {
            return item;
          }
    
          if (typeof perm === "object" && perm !== null) {
            return item;
          }
    
          return null;
        })
        .filter(Boolean);
    };

  const filteredMenuItems = filterMenuByPermission(menuItems, permissionMap);
    return (
      <div className="div sticky-top ">
        <nav className="navbar navbar-expand-md bg-white p-0 m-0 sticky-top navbarmain mainnavbar">
          <div className="container-fluid navBar-bg py-2 px-3 d-flex justify-content-between align-items-center">
        
            <div className="d-flex align-items-center gap-0">
              <a
                className={`navbar-brand m-0 company_logo-nav ${
                  sidebarOpen ? "logo-open-nav" : "logo-close-nav"
                }`}
                href="/dashboard"
              >
                <img
                  className="company-logo-manu"
                  src={sidebarOpen ? logo : logo}
                  alt="Logo"
                />
              </a>
        
              <div className="px-1 py-1 mt-1 sidebar-toggle-btn">
                <img
                  src={sidebarOpen ? arrowRight : arrowLeft}
                  alt="Toggle Sidebar"
                  style={{ cursor: "pointer", width: "20px", height: "20px" }}
                  onClick={() => setSidebarOpen(!sidebarOpen)}
                />
              </div>
        
              {/* <p className="mb-0 ps-1 ms-1 navbartitle">{titleName}</p> */}
              
              <p className="mb-0 ps-1 ms-1 navbartitle">{headerTitle}</p>
            </div>
        
            <div className="d-flex align-items-center gap-3 flex-wrap justify-content-end">
        
              <div className="search-box search-box-nav-bar position-relative flex-shrink-0">
                <input
                  type="text"
                  className="form-control ps-5"
                  placeholder="Search here..."
                  onChange={handleSearchChange}
                />
                <i
                  className="bi bi-search position-absolute"
                  style={{
                    top: "50%",
                    left: "15px",
                    transform: "translateY(-50%)",
                    color: "#9ca3af"
                  }}
                ></i>
              </div>
              {currentUserBaseRole !== "SuperiorAdmin" &&
                <div className='register-audit-group-main'>
                <div className="register-audit-group position-relative bg-primary">

                  {/* slider */}
                  <div
                    className="slider bg-white position-absolute top-0 start-0 h-100 rounded-pill border-none"
                    style={sliderStyle}
                  ></div>

                  {/* Register Button Always Visible */}
                  <button
                    ref={registerRef}
                    className={`fw-medium border-none rounded-pill btn-sm px-3 py-1 m-0 ${
                      activeTab === "Registers" ? "text-primary bg-white" : "text-white"
                    }`}
                    onClick={() => modelToggleChange("Registers")}
                  >
                    Register
                  </button>

                  {/* Audit Button – only if user has access */}
                  {hasAuditAccess ? (
                    <button
                      ref={auditRef}
                      className={`fw-medium border-none rounded-pill btn-sm px-3 py-1 m-0 ${
                        activeTab === "Audit" ? "text-primary" : "text-white"
                      }`}
                      onClick={() => modelToggleChange("Audit")}
                    >
                      Audit
                    </button>
                  ) : null}
                </div>
              </div>
              }
              <div className="icon-btn notification position-relative">
                <img src={giftBox} alt="" />
                <span className="badge bg-danger rounded-circle p-1"></span>
              </div>
              <NotificationBell service="Register" />
        
              <div className="nav-item dropdown me-3" ref={profileRef} style={{ position: "relative" }}>
                <div
                  className="d-flex align-items-center gap-2 useIPmain"
                  onClick={() => setIsProfileOpen((prev) => !prev)}
                  style={{ cursor: "pointer" }}
                >
                  <ProfileImage src={profileImgSrc} size={36} className="nav-profile-avatar" />

                  <div className="d-flex flex-column profileName">
                    <span className="fw-bold">{loggedInUser || "User"}</span>
                    <small className="text-muted">{loggedInrole}</small>
                  </div>
                  <i className="">
                    {isProfileOpen ? <GoChevronUp /> :<GoChevronDown />}
                  
                  </i>
                </div>

                {isProfileOpen && (
                  <ul
                    className="dropdown-menu dropdown-menu-end show navDropdownDatas"
                    style={{ position: "absolute", top: "100%", right: 0, display: "block" }}
                  >
                    <p className="text-center mb-0">
                      <ProfileImage
                        src={profileImgSrc}
                        size={50}
                        className="nav-profile-avatar-lg"
                        onClick={handleImageClick}
                      />
                      <input
                      type="file"
                      ref={fileInputRef}
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                      accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                      />
                    </p>
                    <p className="text-center dataName">{loggedInUser || "User"}</p>
                    <p className="text-center dataRole">{loggedInrole}</p>
                    {userProfileUrl ? (
                      <p className="text-center mb-2">
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-danger"
                          onClick={(e) => {
                            e.stopPropagation();
                            setOpenRemoveProfile(true);
                          }}
                        >
                          Remove profile
                        </button>
                      </p>
                    ) : null}
                    <hr />

                    <li className='datali'>
                      <a className="dropdown-item" href="/reset_password">
                        <FiLogOut /> Change Password
                      </a>
                    </li>
                    <li className='datali'>
                      <a  className="dropdown-item " href='#' onClick={handleClickOpenlogout}>
                        <RiLockPasswordFill /> Logout
                      </a>
                    </li>
                  </ul>
                )}
              </div>


            </div>
          </div>
            <React.Fragment>
              <Dialog
                  open={openlogout}
                  onClose={handleCloselogout}
                  handleLogout={handleLogout}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
              >
                  <DialogTitle id="alert-dialog-title">
                      {"Logout ?"}
                  </DialogTitle>
                  <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                          Are you sure you want to logout?
                      </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                      <Button onClick={handleCloselogout}>Cancel</Button>
                      <Button onClick={handleLogout} autoFocus>
                          OK
                      </Button>
                  </DialogActions>
              </Dialog>
              <Dialog
                  open={openRemoveProfile}
                  onClose={() => setOpenRemoveProfile(false)}
                  aria-labelledby="remove-profile-title"
              >
                  <DialogTitle id="remove-profile-title">
                      Remove profile?
                  </DialogTitle>
                  <DialogContent>
                      <DialogContentText>
                          Are you sure you want to remove your profile photo?
                      </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                      <Button onClick={() => setOpenRemoveProfile(false)}>Cancel</Button>
                      <Button onClick={handleRemoveProfile} autoFocus color="error">
                          Yes, remove
                      </Button>
                  </DialogActions>
              </Dialog>
            </React.Fragment>

        </nav>
        <nav className="navbar navbar-expand-lg bg-white mobilenavbar">
          <div className="container-fluid">
            <NavLink className="navbar-brand d-flex align-items-center" to="/">
              <img
                src={logo} 
                alt="Logo"
                height="35"
                className="me-2"
              />
            </NavLink>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#mainNavbar"
              aria-controls="mainNavbar"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse datanavbartextsize" id="mainNavbar">
              <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                <li className='text-center'>
                {currentUserBaseRole !== "SuperiorAdmin" &&
              // <div className='register-audit-group-main'>
              //   <div className="register-audit-group position-relative  bg-primary">
              //     <div
              //       className="slider bg-white position-absolute top-0 start-0 h-100 rounded-pill  border-none"
              //       style={sliderStyle}
              //     ></div>
          
              //     <button
              //       ref={registerRef}
              //       type="button"
              //       className={` fw-medium border-none rounded-pill btn-sm  ${
              //         activeTab === "Registers" ? "text-primary bg-white" : "text-white"
              //       }`}
              //       style={{ maxWidth:"250px" }}
              //       onClick={() => modelToggleChange("Registers")}
              //     >
              //       Register
              //     </button>
          
              //     <button
              //       ref={auditRef}
              //       type="button"
              //       className={` fw-medium border-none rounded-pill btn-sm ${
              //         activeTab === "Audit" ? "text-primary" : "text-white "
              //       }`}
              //       style={{ maxWidth:"250px" }}
              //       onClick={() => modelToggleChange("Audit")}
              //     >
              //       Audit
              //     </button>
              //   </div>
              // </div>
                <div className='register-audit-group-main'>
                <div className="register-audit-group position-relative bg-primary">

                  {/* slider */}
                  <div
                    className="slider bg-white position-absolute top-0 start-0 h-100 rounded-pill border-none"
                    style={sliderStyle}
                  ></div>

                  {/* Register Button Always Visible */}
                  <button
                    ref={registerRef}
                    className={`fw-medium border-none rounded-pill btn-sm px-3 py-1 m-0 ${
                      activeTab === "Registers" ? "text-primary bg-white" : "text-white"
                    }`}
                    onClick={() => modelToggleChange("Registers")}
                  >
                    Register
                  </button>

                  {/* Audit Button – only if user has access */}
                  {hasAuditAccess ? (
                    <button
                      ref={auditRef}
                      className={`fw-medium border-none rounded-pill btn-sm px-3 py-1 m-0 ${
                        activeTab === "Audit" ? "text-primary" : "text-white"
                      }`}
                      onClick={() => modelToggleChange("Audit")}
                    >
                      Audit
                    </button>
                  ) : null}
                </div>
              </div>
              }
                </li>
                {filteredMenuItems.map((item, index) => (
                  <NavItem item={item} key={index} />
                ))}

                <li className="nav-item dropdown me-3">
                  <a
                    className="nav-link dropdown-toggle d-flex align-items-center gap-2 useIPmain"
                    href="#"
                    id="navbarProfileDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <ProfileImage src={profileImgSrc} size={35} />

                    <div className="d-flex flex-column profileName">
                      <span className="fw-bold">{loggedInUser || "User"}</span>
                      <small className="text-muted">{loggedInrole}</small>
                    </div>
                  </a>

                  <ul
                    className="dropdown-menu dropdown-menu-end navDropdownDatas"
                    aria-labelledby="navbarProfileDropdown"
                  >
                    <p className="text-center mb-0">
                      <ProfileImage
                        src={profileImgSrc}
                        size={50}
                        onClick={handleImageClick}
                      />
                      <input
                        type="file"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        onChange={handleFileChange}
                        accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                      />
                    </p>
                    <p className="text-center dataName">{loggedInUser || "User"}</p>
                    <p className="text-center dataRole">{loggedInrole}</p>
                    {userProfileUrl ? (
                      <p className="text-center mb-2">
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-danger"
                          onClick={(e) => {
                            e.preventDefault();
                            setOpenRemoveProfile(true);
                          }}
                        >
                          Remove profile
                        </button>
                      </p>
                    ) : null}
                    <hr />

                    <li className="datali">
                      <a className="dropdown-item" href="/reset_password">
                        <FiLogOut /> Change Password
                      </a>
                    </li>
                    <li className="datali">
                      <a className="dropdown-item" href="#" onClick={handleClickOpenlogout}>
                        <RiLockPasswordFill /> Logout
                      </a>
                    </li>
                  </ul>
                </li>

              </ul>
            </div>
          </div>
        </nav>
      </div>
  );
};

const NavItem = ({ item }) => {
  const hasChildren = item.children && item.children.length > 0;

  if (hasChildren) {
    return (
      <li className="nav-item dropdown">
        <a
          className="nav-link dropdown-toggle"
          href="#"
          role="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          {item.title}
        </a>
        <ul className="dropdown-menu">
          {item.children.map((child, i) => (
            <li key={i}>
              {child.children && child.children.length > 0 ? (
                <SubDropdown child={child} />
              ) : (
                <NavLink className="dropdown-item" to={child.link}>
                  {child.title}
                </NavLink>
              )}
            </li>
          ))}
        </ul>
      </li>
    );
  }

  return (
    <li className="nav-item">
      <NavLink className="nav-link" to={item.link}>
        {item.title}
      </NavLink>
    </li>
  );
};

const SubDropdown = ({ child }) => {
  const hasChildren = child.children && child.children.length > 0;

  return (
    <li className="dropdown-submenu position-relative">
      <a
        href="#"
        className={`dropdown-item${hasChildren ? " dropdown-toggle" : ""}`}
        data-bs-toggle={hasChildren ? "dropdown" : ""}
      >
        {child.title}
      </a>

      {hasChildren && (
        <ul className="dropdown-menu">
          {child.children.map((sub, j) => (
            <li key={j}>
              <NavLink className="dropdown-item" to={sub.link}>
                {sub.title}
              </NavLink>
            </li>
          ))}
        </ul>
      )}
    </li>
  );
};

export default Navbar;
